<h4 class="title text-center" mat-dialog-title>Cambio de contraseña</h4>
<mat-dialog-content [formGroup]="passForm" >
  <div class= "row content-center coment">
    <div class="col-sm-12 col-md-12 col-xl-12 alert alert-danger" *ngIf="error" >
      <span>
        {{error}}
      </span>
    </div>
    <br>
    <div class="col-sm-12 col-md-12 col-xl-12">
    <span>Para aumentar las medidas de seguridad se han mejorado las politicas de contraseñas por lo que te pedimos considerar:
    </span>
    <ul>
      <li>longitud de 8 caracteres.</li>
      <li>Mayúsculas (A-Z).</li>
      <li>Minúsculas (a-z).</li>
      <li>Números (0-9).</li>
      <li>Símbolos (e.g. #,$,%,@,!).</li>
      <li>La contraseña no deben contener más de 3 caracteres consecutivos ( e.g. 123,abc).</li>
    </ul>
  </div>
</div>
  <div class="row content-center">
    <div class="col-sm-6 col-md-6 col-xl-6">
      <mat-form-field style="width: 85%">
        <input type="password"  #pass formControlName ="pass"  maxlength="8" matInput placeholder="Contraseña">
        <mat-error>
          La <strong>contraseña</strong> debe cumplir las politicas <br>
          y esta no debe haberse usado con anterioridad.
        </mat-error>
      </mat-form-field>
      <button class="pass border-0 btn btn-outline-primary" (click)="pass.type=pass.type=='password'?'text':'password'">
        <ng-container *ngIf="pass.type=='password'; else elsePass">
          <span class="material-icons">visibility</span>
        </ng-container>
        <ng-template #elsePass>
          <span class="material-icons">visibility_off</span>
        </ng-template>
      </button>
    </div>
  </div>
  <div class="row content-center">
    <div class="col-sm-6 col-md-6 col-xl-6">
      <mat-form-field style="width: 85%">
        <input type="password" #passConfirmation formControlName ="passConfirmation"  maxlength="8" matInput placeholder="Confirmar contraseña">
      </mat-form-field>
      <button class="pass border-0 btn btn-outline-primary" (click)="passConfirmation.type=passConfirmation.type=='password'?'text':'password'">
        <ng-container *ngIf="passConfirmation.type=='password'; else elsePassConfirmation">
          <span class="material-icons">visibility</span>
        </ng-container>
        <ng-template #elsePassConfirmation>
          <span class="material-icons">visibility_off</span>
        </ng-template>
      </button>
    </div>
  </div>
  
  <div class="row content-center">
    <div class="col-sm-6 col-md-6 col-xl-6">
    <div class=" small mat-error" *ngIf="passForm.errors">
      La <strong>contraseña</strong> debe ser igual a la confirmación.
    </div>
  </div>
</div>

</mat-dialog-content>
<mat-dialog-actions  align="end">
  <span class="danger">
    * Para mayor información sobre las politicas de información de contraseña comunicarse con su supervisor.
  </span>
  <button (click)='save()' cdkFocusInitial class="btn btn-primary ml-2">{{data.confirmButton}}</button>
  <br>
</mat-dialog-actions>
<br>
